<template>
  <div>
    <Row>
      <div className="workOrder_info">
        <div className="common_title">
          功能未开通，联系程经理:18015525715
        </div>
      </div>
    </Row>
  </div>
</template>
<script>
import Clipboard from "clipboard";

export default {
  name: "orderInfo",
  components: {},
  props: {
    kv: null,
    workId: {
      type: String,
      value: "",
    },
    callId: {
      type: String,
      value: "",
    },
  },

  data() {
    return {}
  },
  created() {
  },
  mounted() {
  },
  methods: {},
};
</script>
<style lang="less" scoped>
.workOrder_info {
  display: flex;
  justify-content: space-between;
  width: 100%;
  background: #fff;
  height: 600px;
  border-radius: 5px;

  .left {
    margin-left: 40px;
  }

  .right {
    display: flex;
    align-items: center;
    margin-right: 45px;

    .margin_middle {
      margin-left: 90px;
      margin-right: 30px;
    }
  }

  .title {
    color: #000;
    font-size: 13px;
    font-weight: 500;
  }
}

.workOrder_content {
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
  background: #fff;
  width: 100%;
  border-radius: 5px;

  .title {
    color: #000;
    font-size: 13px;
    font-weight: 600;
  }

  .item_box {
    display: flex;
  }
}

.workOrder_br {
  height: 1px;
  width: 100%;
  background: #f7f7f7;
}

.common_title {
  color: #000;
  font-size: 20px;
  font-weight: 5;
  text-align: left;
  margin-top: 5px;
  margin-left: 5px
}

.common_image {
  width: 60px;
  height: 60px;
  border-radius: 2px;
  background: #f7f7f7;
}

.common_image_weixiu {
  width: 60px;
  height: 160px;
  border-radius: 2px;
  background: #fff;
  display: flex;
}

.common_color {
  color: #666;
}
</style>
